<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { SaleOfferQuotation } from '$storefront';

  defineProps({
    offer: { type: Object, required: true },
    quotations: { type: Array as PropType<SaleOfferQuotation[]>, required: true },
  });
</script>
<template>
  <div class="quotations">
    <SfTile>
      <div class="quotations__list">
        <OfferQuotation v-for="quotation in quotations" :offer="offer" :quotation="quotation" />
      </div>
    </SfTile>
  </div>
</template>
<style scoped lang="scss">
  .quotations {
    flex-grow: 0;
    width: 100%;

    &__list {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }
</style>
